import { FormGroup } from "@blueprintjs/core";
import TextWidget from "common/form/widgets/TextWidget";
import { IFieldProps } from "decorator-form";
import React from "react";

/**
 * TODO make this user dictionary entry form + allow translation from here
 */

export interface ILabelFieldValue {
	k: string;
	v: string;
}

export function LabelField(props: IFieldProps<ILabelFieldValue>): JSX.Element {

	const { formData = {} as ILabelFieldValue, schema = {}, onChange } = props;

	return (
		<FormGroup label={schema.title} helperText={schema.description}>
			<TextWidget
				placeholder="Key"
				value={formData.k}
				onChange={(k) => onChange({...formData, k})}
			/>
			<div style={{paddingBottom: '15px'}} />
			<TextWidget
				placeholder="Default Value"
				value={formData.v}
				onChange={(v) => onChange({...formData, v})}
			/>
		</FormGroup>
	);
}



// WEBPACK FOOTER //
// ./src/common/form/fields/label/LabelField.tsx